export type SupplyTypeStatusDto =
  | string
  | {
      code?: string;
      name?: string;
      label?: string;
      value?: string;
      tone?: string;
    };

export type SupplyTypeDto = {
  uuid: string;
  name: string;
  description: string | null;
  status: SupplyTypeStatusDto;
  enabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export type SupplyTypeRequest = {
  name: string;
  description: string | null;
};

export type SupplyTypeListQuery = {
  name?: string;
  description?: string;
  enabled?: boolean;
  page?: number;
  size?: number;
  sort?: string;
};

export type SupplyTypeListResult = {
  items: SupplyTypeDto[];
  total: number;
};

export type SupplyTypeStatusLabel = 'Activo' | 'Inactivo';

export function supplyTypeStatusLabel(dto: SupplyTypeDto): SupplyTypeStatusLabel {
  const status = dto.status;
  if (status && typeof status === 'object') {
    if (status.tone === 'danger') return 'Inactivo';
    if (status.tone === 'success') return 'Activo';
    return classifyStatusName(status.name ?? status.label ?? status.code ?? '');
  }
  if (typeof status === 'string') {
    return classifyStatusName(status);
  }
  if (typeof dto.enabled === 'boolean') {
    return dto.enabled ? 'Activo' : 'Inactivo';
  }
  return 'Activo';
}

function classifyStatusName(raw: string): SupplyTypeStatusLabel {
  const normalized = raw.trim().toLowerCase();
  if (
    normalized === 'inactivo' ||
    normalized === 'inactive' ||
    normalized === 'disabled' ||
    normalized.startsWith('inactiv')
  ) {
    return 'Inactivo';
  }
  return 'Activo';
}
